const ERROR_MESSAGE = "Could not open Explorer in new tab.";

export function openExplorerInNewTab(address: string): void {
  const explorerUrl = import.meta.env.VITE_EXPLORER_URL;

  if (!explorerUrl) {
      console.error(ERROR_MESSAGE);
      console.error("Explorer URL is not defined in environment variables.");
      return;
  }

  const subdomain: string = (!address || !address.startsWith("0x") || address.length !== 42) ? "/tx/" : "/address/";
  if (!window) {
      console.error(ERROR_MESSAGE);
      console.error("Window object is not defined.");
      return;
  }
  const windowProxy = window.open(explorerUrl + subdomain + address, "_blank");
  if (!windowProxy) {
      console.error(ERROR_MESSAGE);
      console.error("Could not open new tab.");
      return
  }
  windowProxy.focus();
}
